module.exports = __webpack_public_path__ + "img/promptpay.735c0d7b.png";